const getIdIfExist = (object) => object && object.hasOwnProperty('id') ? object.id : object;

export default getIdIfExist;
